import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { class: "flex items-center space-x-3 h-16" }
const _hoisted_3 = { class: "flex items-center truncate" }
const _hoisted_4 = {
  key: 0,
  class: "hidden md:flex md:flex-row items-center flex-grow"
}
const _hoisted_5 = {
  key: 1,
  class: "-mr-2 flex md:hidden flex-grow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: "nav",
    color: _ctx.color,
    variant: _ctx.variant
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "branding")
          ]),
          (_ctx.hasMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "menu")
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["inline-flex items-center justify-center p-2 ml-auto rounded-md", _ctx.buttonClasses]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggle && _ctx.handleToggle(...args)))
                }, [
                  _hoisted_6,
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["h-6 w-6", { hidden: _ctx.open, block: !_ctx.open }]),
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "aria-hidden": "true"
                  }, _hoisted_8, 2)),
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["h-6 w-6", { hidden: !_ctx.open, block: _ctx.open }]),
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "aria-hidden": "true"
                  }, _hoisted_10, 2))
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["px-4 py-2 md:hidden", { hidden: !_ctx.open }])
      }, [
        _renderSlot(_ctx.$slots, "menu")
      ], 2)
    ]),
    _: 3
  }, 8, ["color", "variant"]))
}